import ApiClient from './ApiClient';

class IaAgentsAPI extends ApiClient {
  constructor() {
    super('ia_agents', { accountScoped: true, apiVersion: 'v2' });
  }
}

export default new IaAgentsAPI();
